<template>
  <div class="bill-detail">
    <!--标题栏-->
    <app-header title="账单详情">
      <!-- <div slot="tips" @click="showCheck">
          <div class="header-right">续费</div>
        </div> -->
    </app-header>
    <ul class="bill-detail-list">
      <li v-for="(item, index) in storeOrServiceList" :key="index">
        <!-- <checkbox v-model="checkedIds" class="list-checkbox" :value="item.id" v-if="isShowCheck"></checkbox> -->
        <div class="li-list">
          <div class="bill-store">{{ item.groupName }}</div>
          <div class="bill-product">{{ item.productName }}</div>
          <div class="bill-time">剩余时间：<span>{{ caclLastDuration(item.effectiveTime, item.expireTime) }}天</span></div>
        </div>
      </li>
    </ul>
    <Button class="submit-btn" @click="renew">一键续费</Button>
  </div>
</template>

<script>
import { commonMixin } from 'common/js/mixin';
import apis from 'api/index';
// import { Checkbox } from 'vue-checkbox-radio';
import moment from 'moment';

export default {
  mixins: [commonMixin],
  components: {
    // Checkbox
  },
  created() {
    this.fetchBillDetail();
  },
  data() {
    return {
      pageNumber: 1,
      pageSize: 10,
      storeOrServiceList: [],
      storeOrServiceTotal: 0,
      // checkedIds: [],
      // isShowCheck: false
    }
  },
  methods: {
    // showCheck() {
    //   this.isShowCheck = true;
    // },
    async renew() {
      try {
        let params = {
          ids: [this.$route.params.id]
        };
        const res = await apis.renewOrder(JSON.stringify(params));
        this.showDialog('支付成功','alert' , () => {
          this.$router.go(-1);
        });
      } catch(err) {
        console.error(err);
      }
    },
    // 计算剩余时间 = 过期时间 - 生效时间
    caclLastDuration(effectiveTime, expireTime) {
      let duration = moment(expireTime).valueOf() - moment(effectiveTime).valueOf();
      return parseInt(moment.duration(duration).asDays());
    },
    async fetchBillDetail() {
      try {
        let params = {
          moduleOrderId	: this.$route.params.id,
          no: this.pageNumber,
          limit: this.pageSize,
        };
        const res = await apis.getStoreOrService(params);
        this.storeOrServiceList = this.storeOrServiceList.concat(res.records);
        this.storeOrServiceTotal = res.total;
      } catch(err) {
        console.error(err);
      }
    }
  }
}
</script>

<style lang="scss" scoped  src="./bill.scss"></style>

